module.exports = __webpack_public_path__ + "media/images/Mastercard-ee893eab83d1304452f3cad631be69a4.svg";